module.exports = {
      id: "icon-pause-usage",
      viewBox: "0 0 17.726 22.137",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }